import React from 'react';
import './HRCopilotGrowSection.css';

const BusinessGrowthSection = () => {
  return (
    <div className="bgs-wrapper">
      <div className="bgs-container">
        
        {/* LEFT COLUMN */}
        <div className="bgs-content-left">
          <div className="bgs-header">
            <p className="bgs-subtitle">Humanex WORKFLOW AUTOMATION</p>
            <h1 className="bgs-title">
              <span className="bgs-title-highlight">Get your Business</span>
              <span className="bgs-title-dark">Right up there!</span>
            </h1>
          </div>

          <div className="bgs-description-block">
            <p className="bgs-text">
              Humanex helps organizations automate their HR processes by 
              simplifying onboarding, task allocation, document handling and 
              employee management in one centralized dashboard.
            </p>
            <p className="bgs-text">
              Replace manual paperwork with automated checklists, instant 
              notifications and structured workflows. Ensure that every new hire 
              completes required steps without delays or follow-ups.
            </p>
            <p className="bgs-text">
              Enable HR teams to assign tasks to multiple departments, track their 
              progress in real time and maintain complete transparency throughout 
              the employee lifecycle.
            </p>
          </div>
        </div>

        {/* MIDDLE COLUMN */}
        <div className="bgs-content-center">
          <div className="bgs-text-column">
            <p className="bgs-text">
              Humanex streamlines employee onboarding by auto-generating role-based 
              workflows, integrating documents, and sending automated reminders 
              for pending tasks—reducing HR workload by more than 70%.
            </p>
            <p className="bgs-text">
              Its smart automation ensures all employee data, agreements, policy 
              acknowledgments and forms are stored securely, reducing compliance 
              risks and manual errors.
            </p>
            <p className="bgs-text">
              With built-in collaboration tools, HR, managers and new employees 
              stay aligned. Every action is time-stamped, tracked and visible 
              to the admin for complete accountability.
            </p>
            <p className="bgs-text">
              Humanex allows companies to set up repeatable workflows for 
              onboarding, exits, document submissions, ID creation and much more. 
              No process is forgotten, delayed or duplicated.
            </p>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="bgs-content-right">
          <div className="bgs-text-column">
            <p className="bgs-text">
              Managers can quickly review progress, approve documents and monitor 
              employee readiness through intuitive dashboards. Humanex centralizes 
              communication and reduces dependency on email follow-ups.
            </p>
          </div>

          <div className="bgs-image-wrapper">
            <img 
              src="https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/img-blog-34-1280x1280.jpg" 
              alt="Team collaboration"
              className="bgs-team-image"
            />
          </div>

          <div className="bgs-text-column bgs-bottom-text">
            <p className="bgs-text">
              From automated onboarding to structured workflows, Humanex ensures 
              a smooth transition for every employee. Improve productivity, teamwork,
              and HR efficiency with one powerful platform.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default BusinessGrowthSection;
